import { PCDownloadModal } from 'components/common/modal'
import { ArrowDownSvg } from 'components/top/extend/svg/arrow-down'
import { Fragment, useEffect, useRef, useState } from 'react'
import { ELEMENT_ID, ROUTE_PATHS } from 'utils/constant'
import { getGTM, throttle } from 'utils/functions'

type Props = {
  isTopPage?: boolean
}

export function PCHeader({ isTopPage = false }: Props) {
  const logoRef = useRef<HTMLAnchorElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const [open, setOpen] = useState(false)

  const onOpenModal = () => {
    document.documentElement.classList.toggle('block', true)
    setOpen(true)
  }

  const onCloseModal = () => {
    document.documentElement.classList.toggle('block', false)
    setOpen(false)
  }

  useEffect(() => {
    const footer = document.getElementById('pcfooter')
    const pcFv = document.getElementById('pcfv')

    const onScroll = () => {
      const { scrollY } = window

      const bpFv = Number(pcFv?.clientHeight)
      const bpFooter = Number(footer?.offsetTop)

      const isHeaderBlur = String(scrollY > bpFv)

      containerRef.current?.setAttribute('data-header-blur', isHeaderBlur)

      const logoInitState = isTopPage ? '0' : '1'
      const logoState =
        scrollY <= bpFv ? logoInitState : scrollY <= bpFooter ? '2' : '1'

      logoRef.current?.setAttribute('data-logo-state', logoState)
    }

    const throttleScroll = throttle(onScroll, 100)

    onScroll()
    window.addEventListener('scroll', throttleScroll)
    return () => {
      window.removeEventListener('scroll', throttleScroll)
    }
  }, [])

  return (
    <Fragment>
      <PCDownloadModal open={open} onClose={onCloseModal} />
      <header
        ref={containerRef}
        data-header-blur='false'
        className='fixed w-full d-py-[25px_1440] flex items-center justify-between d-px-[40px_1440] z-40 top-0'
      >
        <a
          ref={logoRef}
          href={ROUTE_PATHS.TOP}
          aria-label='logo'
          {...getGTM({
            event_name: 'button_click',
            content_type: 'header',
            content_id: 'comado_ロゴ',
          })}
          data-logo-state='0'
          className='d-w-[144px_1440] d-h-[36px_1440] bg-no-repeat bg-contain'
        />

        <nav className='flex items-center'>
          <a
            href={`${ROUTE_PATHS.TOP}#${ELEMENT_ID.FOUR_THINGS_YOU_CAN_DO}`}
            className='font-semibold d-text-[14px_1440] d-leading-[48px_1440] d-tracking-[1.4px_1440]'
          >
            Comadoでできる4つのこと
          </a>
          <a
            href={`${ROUTE_PATHS.TOP}#${ELEMENT_ID.HOW_TO_USER}`}
            className='font-semibold d-text-[14px_1440] d-leading-[48px_1440] d-tracking-[1.4px_1440] d-ml-[24px_1440]'
          >
            ご利用方法
          </a>
          <a
            href={`${ROUTE_PATHS.TOP}#${ELEMENT_ID.FAQ}`}
            className='font-semibold d-text-[14px_1440] d-leading-[48px_1440] d-tracking-[1.4px_1440] d-ml-[24px_1440]'
          >
            よくある質問
          </a>

          <a
            {...getGTM({
              event_name: 'button_click',
              content_type: 'TOP_Point',
              content_id: 'ポイントとは',
            })}
            href={ROUTE_PATHS.POINT}
            className='d-py-[12px_1440] d-px-[32px_1440] d-ml-[26px_1440] d-border-[2px_1440] border-primary-600 hover:!shadow-none hover:border-primary-700 transform transition-all duration-150 hover:translate-y-[4px] flex items-center rounded-full bg-white'
            style={{ boxShadow: '0px 4px 0px 0px #ECBF1E' }}
          >
            <span className='d-text-[14px_1440] d-leading-[28px_1440] d-tracking-[1.4px_1440] font-semibold'>
              ポイントとは
            </span>
            <ArrowDownSvg className='transform -rotate-90 d-w-[24px_1440] d-h-[24px_1440] d-ml-[8px_1440]' />
          </a>

          <button
            {...getGTM({
              event_name: 'download_click',
              content_type: 'header',
              content_id: 'header_DL',
            })}
            type='button'
            className='outlined-none d-py-[12px_1440] d-px-[40px_1440] d-ml-[16px_1440] d-border-[2px_1440] border-black hover:!shadow-none transform transition-all duration-150 hover:translate-y-[4px] flex items-center rounded-full bg-[#494949]'
            style={{ boxShadow: '0px 4px 0px 0px black' }}
            onClick={onOpenModal}
          >
            <span className='d-text-[24px_1440] d-leading-[30px_1440] d-tracking-[2.4px_1440] font-semibold text-white'>
              無料でダウンロード
            </span>
          </button>
        </nav>
      </header>
    </Fragment>
  )
}
